module.exports = __webpack_public_path__ + "static/media/rising_star_grey.16e05ed9.svg";